import React from "react";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Popconfirm } from "antd";
import { useSelector } from "react-redux";

const ReportItem = ({ data, handleEditReport, handleDeleteReport, userId }) => {
  const themeMode = useSelector((state) => state.themeMode);

  const formattedText = (text) => {
    return text.split("\n").map((line, index) => (
      <span key={index}>
        {line.split(" ").map((text, wordIndex) => (
          <span key={`${index}-${wordIndex}`}>{text} </span>
        ))}
        <br />
      </span>
    ));
  };

  return (
    <div
      className={`reportItemSection ${
        themeMode.themeMode
          ? "reportItemSection-dark"
          : "reportItemSection-light"
      }`}
    >
      <div
        className={`person-info-body ${
          themeMode.themeMode
            ? "person-info-body-dark"
            : "person-info-body-light"
        }`}
      >
        <div className="person-info-header">
          <div
            className={`person-avatar ${
              themeMode.themeMode ? "border-color-dark" : "border-color-light"
            }`}
          >
            <img src={data.user?.avatar} alt="avatar" className="person-logo" />
            <div className="person-name">
              {data.user?.name || "Unknown user"}
            </div>
          </div>
          {userId === data.user?._id && (
            <div className="person-action">
              <Button
                type="primary"
                icon={<EditOutlined />}
                size="small"
                style={{ fontSize: 10 }}
                onClick={() => handleEditReport(data)}
              />

              <Popconfirm
                title="Delete this update?"
                description="Are you sure to delete this update?"
                okText="Yes"
                cancelText="No"
                onConfirm={() => handleDeleteReport(data._id)}
              >
                <Button
                  color="danger"
                  variant="solid"
                  icon={<DeleteOutlined />}
                  size="small"
                  style={{ fontSize: 10 }}
                />
              </Popconfirm>
            </div>
          )}
        </div>
        <div className="person-info-content">
          <div className="person-info-item">
            <div className="person-info-list">
              <div className="person-info-list-item">
                {formattedText(data.content)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportItem;
